<template>
  <div class="custom-input">
    <v-subheader
      class="pa-0"
      v-if="label"
    >
      <label
        :for="id"
        class="neutral-cold-051--text text-body-3"
      >{{ label }}</label>
    </v-subheader>
    <v-text-field
      :id="id"
      v-bind="{ ...$attrs, ...commonAttrs }"
      v-on="$listeners"
      autocomplete="off"
    >
      <template
        v-for="(_, scopedSlotName) in $scopedSlots"
        #[scopedSlotName]="slotData"
      >
        <slot
          :name="scopedSlotName"
          v-bind="slotData"
        />
      </template>
      <template
        v-for="(_, slotName) in $slots"
        #[slotName]
      >
        <slot :name="slotName" />
      </template>
      <template slot="append-outer">
        <v-icon size="16">
          $vuetify.icons.inputErrorIcon
        </v-icon>
      </template>
    </v-text-field>
  </div>
</template>

<script>
export default {
  name: 'Input',
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    }
  },
  computed: {
    commonAttrs() {
      return {
        label: '',
        persistentHint: true,
        outlined: true,
        dense: true,
        hideDetails: false,
        class: {
        }
      };
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep.custom-input {
  .v-text-field--outlined input {
    font-size: 14px;
    font-weight: 400;
    line-height: 19px;
    &::placeholder {
      font-size: 14px;
      font-weight: 400;
      line-height: 19px;
      color: $neutral-042;
    }
  }
  .v-input {
    .v-input__slot {
      min-height: auto !important;
    }

    // Default Style
    fieldset {
      background: $neutral-cold-058;
      border: 1px solid $neutral-cold-053;
      transition: all 0.3s ease-in-out;
    }

    // Fill Style
    &.v-input--is-label-active:not(.v-input--is-focused, .v-input--is-disabled, .v-input--is-readonly) fieldset {
      border-color: $neutral-cold-052;
    }

    // Hover Style
    &:hover fieldset {
      border-color: $neutral-cold-052;
    }

    // Focus Style
    &.v-input--is-focused fieldset{
      background: $neutral-047;
      border-color: $primary-001;
      box-shadow: 0px 0px 0px 2px rgba(64, 143, 255, 0.25);
    }

    // Disabled Style
    &.v-input--is-disabled {
      fieldset {
        background: $neutral-cold-057 !important;
        border-color: $neutral-cold-055 !important;
      }
      input {
        color: $neutral-043 !important;
      }
      input::placeholder{
        color: $neutral-043;
      }

    }

    // Readonly Style
    &.v-input--is-readonly {
      input {
        color: $neutral-042;
        &::placeholder {
          color: $neutral-042;
        }
      }
      fieldset{
        background: $neutral-cold-057;
        border-color: $neutral-cold-055;
        box-shadow: none;
      }
    }

    // Error Style
    &.error--text fieldset,
    &.error--text.v-input.v-input--is-label-active:not(.v-input--is-focused, .v-input--is-disabled, .v-input--is-readonly) fieldset {
      background: $neutral-047;
      border-color: $danger-021;
      box-shadow: 0px 0px 0px 2px rgba($danger-021, 25%)
    }
    .v-messages{
      margin-left: 22px;
    }
    .v-input__append-outer{
      position: absolute;
      top: 25px;
      left: 0;
      margin-left: 0;
      display: none;
    }
    &.error--text .v-input__append-outer{
      display: inline-flex;
    }

    // Prepend Inner Icon Style
    .v-input__prepend-inner {
      margin-top: 7px;
      .v-input__icon--prepend-inner {
        width: 16px;
        height: 16px;
        min-width: 16px;
        .v-icon__component {
          height: 16px;
          width: 16px;
        }
      }
      .v-icon.v-icon {
        z-index: 2;
        color: $neutral-042 !important;
        caret-color: $neutral-042 !important;
      }
    }

    // Append Inner Icon Style
    .v-input__append-inner {
      .v-input__icon--append {
        width: 16px;
        height: 16px;
        min-width: 16px;
        .v-icon__component {
          height: 16px;
          width: 16px;
        }
      }
    }
    // text counter
    .v-counter {
      position: absolute;
      top: -16px;
      right: 0;
      color: $neutral-cold-051;
    }
  }

}

</style>
